export default __webpack_public_path__ + "i18n/tr.d670b96461f01b8b1a8df02d60361bb7.json";